import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {CategoryBlock, CategoryDataModel, FullCategoryTree} from "@/models";

export class CategoryService {
    static readonly $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public GetAllCategoriesToTree(query: string, cancelToken?: AbortSignal) {
        return this.baseApiFactory.getData<FullCategoryTree[]>(`/api/Category?${query}`, null, cancelToken, {silent: true});
    }

    SelectCategoryDetail(id: number | string, langCode: string, cancelToken?: AbortSignal) {
        return this.baseApiFactory.getData<any>(`/api/Category/${id}`, {langCode}, cancelToken);
    }

    InsertCategory(value: CategoryDataModel) {
        return this.baseApiFactory.post('/api/Category', value);
    }

    UpdateCategory(value: CategoryDataModel) {
        return this.baseApiFactory.put<boolean>('/api/Category', value);
    }

    UpdateDisplayOrder(values: CategoryDataModel[]) {
        return this.baseApiFactory.put('/api/Category/display-order', values);
    }

    DeleteCategory(id: number) {
        return this.baseApiFactory.delete(`/api/Category/${id}`);
    }

    public CopyCategoryTree(postData: any) {
        return this.baseApiFactory.post(`/api/CategoryCopy/CopyCategoryTree`, postData);
    }

    public CopyIndividualCategory(postData: any) {
        return this.baseApiFactory.post(`/api/CategoryCopy/CopyIndividualCategory`, postData);
    }
}

lazyRegister.service('CategoryService', CategoryService);
